<template>
	<div style="background-color: #fff;margin: 10px;border-radius: 3px;">
		<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;padding-top: 10px;">
			<!--带折叠的搜索start-->
			<div style="overflow: hidden">
				<el-form size="mini" style="display: flex;flex-wrap: wrap;" :style="{'height':isShowCollapse?'auto':'50px'}" ref="searchForm" :model="searchForm" inline label-width="100px">

					<!--收起时显示的搜索项start 4个搜索项为一行-->
					<div v-show="!isShowCollapse" style="width: 80%;display: flex;padding-left: 30px;">


						<el-form-item  label="门店" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								
								<el-option label="非门店商品" :value="0" />
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>
						
						<el-form-item label="名称" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.name" placeholder="商品名称" clearable size="mini" />
						</el-form-item>
						
						
						<el-form-item label="状态" style="width: 23%;display: flex;">
						
							<el-select v-model="searchForm.status" clearable placeholder="商品状态">
								<el-option label="发布" :value="1">发布</el-option>
								<el-option label="草稿" :value="0">草稿</el-option>
							</el-select>
						
						</el-form-item>
						

					

						<el-form-item label="分类" style="width: 23%;display: flex;">
							<el-cascader v-model="searchForm.typeArr" :options="typeOptions" clearable :props="{ expandTrigger: 'hover' }"></el-cascader>
						</el-form-item>



						


					



					</div>
					<!--收起时显示的搜索项end-->

					<!--展开时显示的搜索项start 4个搜索项为一行-->
					<div v-if="isShowCollapse" style="display: flex;flex-wrap: wrap;">

						<el-form-item  label="门店" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option label="非门店商品" :value="0" />
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>
						
						<el-form-item label="名称" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.name" placeholder="商品名称" clearable size="mini" />
						</el-form-item>
						
						
						<el-form-item label="状态" style="width: 23%;display: flex;">
						
							<el-select v-model="searchForm.status" clearable placeholder="商品状态">
								<el-option label="发布" :value="1">发布</el-option>
								<el-option label="草稿" :value="0">草稿</el-option>
							</el-select>
						
						</el-form-item>

						

						<el-form-item label="分类" prop="typeArr" style="width: 23%;display: flex;">
							<el-cascader style="width: 100%;" v-model="searchForm.typeArr" :options="typeOptions" clearable :props="{ expandTrigger: 'hover' }"></el-cascader>
						</el-form-item>

						<el-form-item label="品牌" prop="brand_id" style="width: 23%;display: flex;">
							<el-select v-model="searchForm.brand_id" style="width: 100%;" clearable placeholder="请选择">
								<el-option v-for="(itemByBrand,indexByBrand) in brand_idArr" :key="indexByBrand" :label="itemByBrand.name" :value="itemByBrand.id"></el-option>
							</el-select>
						</el-form-item>


					<!-- 

						<el-form-item label="推荐商品" style="width: 23%;display: flex;">

							<el-select v-model="searchForm.is_recommend" clearable placeholder="是否推荐商品">
								<el-option label="是" :value="1">是</el-option>
								<el-option label="否" :value="0">否</el-option>
							</el-select>

						</el-form-item>

						<el-form-item label="特惠商品" style="width: 23%;display: flex;">

							<el-select v-model="searchForm.is_discount" clearable placeholder="是否特惠商品">
								<el-option label="是" :value="1">是</el-option>
								<el-option label="否" :value="0">否</el-option>
							</el-select>

						</el-form-item>
						
						<el-form-item label="会员商品" style="width: 23%;display: flex;">
						
							<el-select v-model="searchForm.is_vip" clearable placeholder="是否会员商品">
								<el-option label="是" :value="1">是</el-option>
								<el-option label="否" :value="0">否</el-option>
							</el-select>
						
						</el-form-item>
						
						<el-form-item label="课时抵扣" style="width: 23%;display: flex;">
						
							<el-select v-model="searchForm.is_course" clearable placeholder="是否课时抵扣">
								<el-option label="是" :value="1">是</el-option>
								<el-option label="否" :value="0">否</el-option>
							</el-select>
						
						</el-form-item>
						
						<el-form-item label="优惠券抵扣" style="width: 23%;display: flex;">
						
							<el-select v-model="searchForm.is_coupon" clearable placeholder="是否优惠券抵扣">
								<el-option label="是" :value="1">是</el-option>
								<el-option label="否" :value="0">否</el-option>
							</el-select>
						
						</el-form-item>
						
						<el-form-item label="城代商品" style="width: 23%;display: flex;">
						
							<el-select v-model="searchForm.is_store" clearable placeholder="是否城代商品">
								<el-option label="是" :value="1">是</el-option>
								<el-option label="否" :value="0">否</el-option>
							</el-select>
						
						</el-form-item> -->
						
						
						
						<el-form-item label="库存阈值" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.understock" placeholder="" type="number" clearable size="mini" />
						</el-form-item>
						
						
						
						
						
						
						

					</div>
					<!--展开时显示的搜索项end-->

					<div :style="{'width':isShowCollapse?'100%':'13%','justify-content': isShowCollapse?'flex-end':'center' }" style="height: 30px; display: flex;margin: 0;">
						<div style="flex-shrink: 0;margin-right: 20px;display: flex;justify-content: center;align-items: center;cursor:pointer;color: #9A7E9C;font-size: 14px;line-height: 20px; display: flex;margin-left: 20px;" @click="isShowCollapseF()">
							<span v-if="!isShowCollapse">展开</span>
							<span v-else>收起</span>
							<span style="margin-left: 5px;font-size: 20px;line-height: 20px;" :style="{transform:isShowCollapse?'rotate(180deg)':'rotate(0deg)'}">∨</span>
						</div>
						<el-button round style="margin-right: 10px" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
						<el-button round @click="handleReset" size="small">重置</el-button>
						<div v-if="isShowCollapse" style="width: 70px;"></div>
					</div>


				</el-form>
			</div>
			<!--带折叠的搜索end-->

			<!-- 只允许单选的排序start -->
			<div style="margin-top: 10px;display: flex;align-items: center;background-color: #fff;margin-bottom: 10px; justify-content: space-between;">

				<div style="margin-right: 20px;margin-left: 35px;display: flex;align-items: center;">
					<el-button @click="showAddGoodsPop" type="primary" round icon="el-icon-plus" size="mini">添加商品</el-button>

					<!-- <div v-if="searchForm.understock" style="font-size: 13px;margin-left: 20px;">库存预警列表：</div>
					<div v-if="searchForm.status===0" style="font-size: 13px;margin-left: 20px;">仓库商品列表：</div>
 -->

				</div>

				<div class="sortLine" style="font-size: 14px;display: inline-flex; margin-left: 40px; color: #6f6c5f;background-color: #e0f7ed;border-radius: 8px;overflow: hidden;margin-right: 68px;">

					<div class="sortItem dis" @click="sort(-1)" :style="{color: sortIndex==-1?'#fff':'#777','font-weight': sortIndex==-1?'bold':'400','background-color': sortIndex==-1?'#9E819F':''}">
						默认</div>
					<!-- 排序项start -->
					
					
					
					
					<!-- 排序项end -->
					<div class="sortItem dis" @click="sort(1,'sales')" :style="{color: sortIndex==1?'#fff':'#777','font-weight': sortIndex==1?'bold':'400','background-color': sortIndex==1?'#9E819F':''}">
						销量
						<img v-if="sortIndex==1&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==1&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>

					<div class="sortItem dis" @click="sort(2,'price')" :style="{color: sortIndex==2?'#fff':'#777','font-weight': sortIndex==2?'bold':'400','background-color': sortIndex==2?'#9E819F':''}">
						会员价
						<img v-if="sortIndex==2&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==2&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					
					
					
					<div class="sortItem dis" @click="sort(4,'sort')" :style="{color: sortIndex==4?'#fff':'#777','font-weight': sortIndex==4?'bold':'400','background-color': sortIndex==4?'#9E819F':''}">
						排序
						<img v-if="sortIndex==4&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==4&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					<div class="sortItem dis" @click="sort(0,'updated_at')" :style="{color: sortIndex==0?'#fff':'#777','font-weight': sortIndex==0?'bold':'400','background-color': sortIndex==0?'#9E819F':''}">
						更新时间
						<img v-if="sortIndex==0&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==0&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					<div class="sortItem dis" @click="sort(3,'created_at')" :style="{color: sortIndex==3?'#fff':'#777','font-weight': sortIndex==3?'bold':'400','background-color': sortIndex==3?'#9E819F':''}">
						创建时间
						<img v-if="sortIndex==3&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==3&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					

				</div>


			</div>
			<!-- 只允许单选的排序end -->
		</div>


		<!-- 添加商品弹窗start width="50%"-->
		<el-dialog :close-on-click-modal="false" width="1050px" custom-class="m-dialog" title="添加商品" center :visible.sync="isShowAddGoodsPop">
			<add-goods v-if="isShowAddGoodsPop" @success="addAndEditGoodsSuccess"></add-goods>
		</el-dialog>
		<!-- 添加商品弹窗end -->


		<!-- 编辑商品弹窗start width="50%"-->
		<el-dialog :close-on-click-modal="false" width="1050px" custom-class="m-dialog" title="编辑商品" center :visible.sync="isShowEditGoodsPop">
			<edit-goods v-if="isShowEditGoodsPop" :goods_id="rowGoods_id" @success="addAndEditGoodsSuccess"></edit-goods>
		</el-dialog>
		<!-- 编辑商品弹窗end -->


		<!-- 显示商品详情弹窗start width="50%"-->
		<el-dialog :close-on-click-modal="false" width="1050px" custom-class="m-dialog" title="商品详情" center :visible.sync="isShowGoodsDetailPop">
			<show-goods v-if="isShowGoodsDetailPop" :goods_id="rowGoods_id"></show-goods>
		</el-dialog>
		<!-- 显示商品详情弹窗end -->


		<!--表格start :height="tableHeight+'px'"-->
		<!-- :style="{'overflow-x':isMobile?'auto':''}" -->
		<el-table :height="tableHeight" :show-header="false" ref="table" :data="tableData" style="width: 100%;background-color: #fff;margin: 5px;">

			<el-table-column style="width: 100%;">
				<template slot-scope="{ row, index }">
					<div class="tableTem" style="display: flex;margin-left: 20px;">
						<div class="avatar">

							<!--商品图片start-->
							<div style="text-align: center;" class="dis">
								<img :src="row.image" style="width:70px;height:70px;cursor: pointer;" @click="handlePreView(row.image)">
								<!-- <div class="titleFont">主图</div> -->
							</div>
							<!--商品图片end-->

							<div style="width: 180px;">

								<!--头像右侧一个列表项start-->
								<div style="display: flex;">
									<span class="titleFont" style="width: 70px;text-align: right;">id：</span>
									<el-tooltip :content="row.id+''" placement="right">
										<div class="dian dianL">{{row.id}}</div>
									</el-tooltip>
								</div>
								
								
								<div style="display: flex;margin-top: -5px;">
									<span class="titleFont" style="width: 70px;text-align: right;">状态：</span>
									
									<div v-if="row.deleted_at" class="dian dianL" style="color: rgb(255, 106, 0);">草稿</div>
									<div v-else class="dian dianL" style="color: limegreen">发布</div>
									
								</div>
								<!--头像右侧一个列表项end-->
								<div style="display: flex;margin-top: -5px;">
									<span class="titleFont" style="width: 70px;text-align: right;">名称：</span>
									<el-tooltip :content="row.name" placement="right">
										<div class="dian dianL">{{row.name}}</div>
									</el-tooltip>
								</div>

								
								

								<!-- <div style="display: flex;margin-top: -5px;">
									<span class="titleFont" style="width: 70px;text-align: right;">原价：</span>
									<el-tooltip :content="row.original_price+''" placement="right">
										<div class="dian dianL">{{row.original_price}}</div>
									</el-tooltip>
								</div> -->
								
								<div style="display: flex;margin-top: -5px;">
									<span class="titleFont" style="width: 70px;text-align: right;">课时价：</span>
									<el-tooltip :content="row.course+''" placement="right">
										<div class="dian dianL">{{row.course}}</div>
									</el-tooltip>
								</div>

								<div style="display: flex;margin-top: -5px;">
									<span class="titleFont" style="width: 70px;text-align: right;">会员价：</span>
									<el-tooltip :content="row.price+''" placement="right">
										<div class="dian dianL">{{row.price}}</div>
									</el-tooltip>
								</div>


								<div style="display: flex;margin-top: -5px;">
									<span class="titleFont" style="width: 70px;text-align: right;">供货价：</span>
									<el-tooltip :content="row.supply_price+''" placement="right">
										<div class="dian dianL">{{row.supply_price}}</div>
									</el-tooltip>
								</div>
								
								
								<!-- <div style="display: flex;margin-top: -5px;">
									<span class="titleFont" style="width: 70px;text-align: right;">城代价：</span>
									<el-tooltip :content="row.city_price+''" placement="right">
										<div class="dian dianL">{{row.city_price}}</div>
									</el-tooltip>
								</div> -->
								
								<div style="display: flex;justify-content: flex-end;align-items: center;margin-top: -5px;">
									<!-- <template v-if="row.specs_type==2">
									
										<div @click="showPricePop(row)" style="display: flex;padding-right: 5px;cursor: pointer;">
											<span class="titleFont" style="color:rgb(255, 106, 0);">多规格价格</span>
										</div>
									</template> -->
									
									<i class="el-icon-edit" @click="showPricePop(row)" style="cursor: pointer;margin-top: -3px;"></i>
								</div>

								
								



							</div>
						</div>

						<!-- height: 50px; -->
						<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">

							<!-- <li>
								<div class="content">
									<el-tooltip :content="row.is_vip==1?'是':'否'" placement="right">
										<span>{{row.is_vip==1?'是':'否'}}</span>
										
							
									</el-tooltip>
								</div>
								<div class="titleFont dian">会员商品</div>
							</li>
							
						
							
							<li>
								<div class="content">
									<el-tooltip :content="row.is_store==1?'是':'否'" placement="right">
										<span>{{row.is_store==1?'是':'否'}}</span>
										
							
									</el-tooltip>
								</div>
								<div class="titleFont dian">城代商品</div>
							</li>
							

							<li>
								<div class="content">
									<el-tooltip :content="row.is_discount==1?'是':'否'" placement="right">
										<span>{{row.is_discount==1?'是':'否'}}</span>
										

										
									</el-tooltip>
								</div>
								<div class="titleFont dian">特惠商品</div>
							</li>


							<li>
								<div class="content">
									<el-tooltip :content="row.is_recommend==1?'是':'否'" placement="right">

										<span>{{row.is_recommend==1?'是':'否'}}</span>
										
										
									</el-tooltip>
								</div>
								<div class="titleFont dian">推荐商品</div>
							</li>

							<li>
								<div class="content">
									<el-tooltip :content="row.is_course==1?'是':'否'" placement="right">
										<span>{{row.is_course==1?'是':'否'}}</span>
										
							
										
									</el-tooltip>
								</div>
								<div class="titleFont dian">课时抵扣</div>
							</li>
							
							<li>
								<div class="content">
									<el-tooltip :content="row.is_coupon==1?'是':'否'" placement="right">
										<span>{{row.is_coupon==1?'是':'否'}}</span>
										
							
									
									</el-tooltip>
								</div>
								<div class="titleFont dian">优惠券抵扣</div>
							</li>
 -->







						

							<li>
								<div class="content">
									<el-tooltip :content="row.sort+''" placement="right">
										<div class="dian">{{row.sort}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">排序 (倒序)</div>
							</li>

							<li>
								<div class="content">
									<el-tooltip :content="row.sales_count+''" placement="right">
										<div class="dian">{{row.sales_count}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">起售数量</div>
							</li>

							<!-- 一个方块列表项start-->
							<li>
								<div class="content">
									<el-tooltip :content="row.stock+''" placement="right">
										<div class="dian">{{row.stock}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">总库存</div>
							</li>
							<!-- 一个方块列表项end-->

							<li>
								<div class="content">
									<el-tooltip :content="row.sales+''" placement="right">
										<div class="dian">{{row.sales}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">总销量</div>
							</li>



							<li>
								<div class="content">
									<el-tooltip :content="row.specs_type==1?'单规格':'多规格'" placement="right">
										<div class="dian">{{row.specs_type==1?'单规格':'多规格'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">规格类型</div>
							</li>
							
							<li>
								<div class="content">
									<el-tooltip :content="row.express_desc?row.express_desc:'无'" placement="right">
										<div class="dian">{{row.express_desc?row.express_desc:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont dian">发货描述</div>
							</li>
							
							<li style="width: 250px;">
								<div class="content" style="width: 240px;">
									<el-tooltip :content="row.store?row.store.name:'无'" placement="right" style="width: 240px;">
										<div class="dian" style="width: 240px;">{{row.store?row.store.name:'无'}}</div>
									</el-tooltip>
								</div>
								<div class="titleFont">门店名称</div>
							</li>

							<li>
								<el-tooltip :content="row.created_at+''" placement="right">

									<div class="content dis">
										{{row.created_at | timeBreak2}}


									</div>
								</el-tooltip>
								<div class="titleFont dian">创建时间</div>
							</li>

							<li>
								<el-tooltip :content="row.updated_at+''" placement="right">

									<div class="content">
										{{row.updated_at | timeBreak2}}

									</div>
								</el-tooltip>
								<div class="titleFont dian">更新时间</div>
							</li>





							<!-- <li>
								<div class="content">
									<el-tooltip :content="row.stateChangeTime" placement="right">
										<span>{{row.stateChangeTime | timeBreak(0)}}</span><span style="margin-left: 6px;">{{row.stateChangeTime | timeBreak(1)}}</span>
									</el-tooltip>
								</div>
								<div class="titleFont">时间2</div>
							</li> -->


						</ul>


						<div style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
							<el-dropdown trigger="hover" style="width: 80px;">
								<el-button size="mini" round type="primary">
									操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">

									<el-dropdown-item>
										<el-button type="primary" size="mini" round @click="showGoodsDetail(row)">查看
										</el-button>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-button type="success" size="mini" round @click="showEditGoods(row)">编辑
										</el-button>
									</el-dropdown-item>
									
									<!-- v-if="!row.deleted_at" -->
									<el-dropdown-item v-if="!row.deleted_at">
										<el-button type="danger" size="mini" round @click="delGoods(row)">删除
										</el-button>
									</el-dropdown-item>
							


								</el-dropdown-menu>
							</el-dropdown>

						</div>


						<!-- <div style="width:205px;display: flex;flex-wrap: wrap;">
							<div style="margin: 5px 0;">
							<el-button type="danger" size="mini" round  style="margin-right: 10px;" 
								@click="showDetailDrawer(row)">查看</el-button>
							</div>
							<div style="margin: 5px 0;">
							<el-button type="success" size="mini" round  style="margin-right: 10px;" 
								@click="showDetailDrawer(row)">查看</el-button>
							</div>
							<div style="margin: 5px 0;">
							<el-button type="info" size="mini" round  style="margin-right: 10px;" 
								@click="showDetailDrawer(row)">查看</el-button>
							</div>
							<div style="margin: 5px 0;">
							<el-button type="warning" size="mini" round  style="margin-right: 10px;"
								@click="showDetailDrawer(row)">查看</el-button>
							</div>
							
						</div> -->

					</div>

				</template>
			</el-table-column>
		</el-table>
		<!--表格end-->

		<!--分页start-->
		<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
			<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
			<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
		</el-row>
		<!--表格end-->

		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->


		<!--多规格价格的弹窗start-->
		<el-dialog width="60%" center :close-on-click-modal="false" footer-hide title="价格列表" :visible.sync="isShowPricePop">
      <div v-if="currentPriceRowGoods_specsArr.length>0" style="display: flex;width: 100%;justify-content: center;align-items: center">
        <div>起售数量：</div>
        <el-input  v-model="sales_count"  placeholder="请输入内容" style="width: 100px"></el-input>
        <!--        <input type="text" v-model="sales_count" style="border: 1px solid black;padding: 5px;text-align: center;width: 100px;border-radius: 10px">-->
      </div>
			<el-table :cell-style="{'text-align':'left'}" :header-cell-style="{'text-align':'center'}" :data="currentPriceRowGoods_specsArr" style="width: 100%">
				<el-table-column label="名称">
					<template slot-scope="scope">
					    <div v-if="scope.row.specs_value_str" style="font-size: 12px;">{{scope.row.specs_value_str}}</div>
						<div v-else style="font-size: 12px;">{{currentPriceRow.name}}</div>
					</template>
				</el-table-column>
				
				
				
				<!-- <el-table-column label="原价">
					<template slot-scope="scope">
					    <el-input class="dd" type="number"  v-model="scope.row.original_price"></el-input>
					</template>
				</el-table-column> -->
        <el-table-column  label="库存">
          <template slot-scope="scope">
            <el-input class="dd" type="number"  v-model="scope.row.stock"></el-input>
          </template>
        </el-table-column>
				<el-table-column label="课时价">
					<template slot-scope="scope">
					    <el-input class="dd" type="number"  v-model="scope.row.course"></el-input>
					</template>
				</el-table-column>
				
				<el-table-column prop="" label="会员价">
					<template slot-scope="scope">
					    <el-input class="dd" type="number"  v-model="scope.row.price" ></el-input>
					</template>
				</el-table-column>
				
				<el-table-column  label="供货价">
					<template slot-scope="scope">
					    <el-input class="dd" type="number"  v-model="scope.row.supply_price"></el-input>
					</template>
				</el-table-column>
				
				<!-- <el-table-column  label="城代价">
					<template slot-scope="scope">
					    <el-input class="dd" type="number"  v-model="scope.row.city_price"></el-input>
					</template>
				</el-table-column> -->
				
				
				
				
			</el-table>
			
			<div class="dis" style="justify-content: flex-end;margin-top: 30px;">
				
				<el-button v-if="currentPriceRowGoods_specsArr.length>0" round style="margin-left: 10px" @click="duoSkuEditBtn" type="primary" size="small">确定</el-button>
			</div>
			
			

		</el-dialog>
		<!--多规格价格的弹窗end-->


		<!-- 推荐图弹窗start -->
		<el-dialog width="30%" center :close-on-click-modal="false" footer-hide :visible.sync="isShowTuiJianTuPop">
			<div>
				<div style="position: relative;justify-content: flex-start;padding-left: 50px;" class="dis">
					<div style="margin-right: 20px;">
						<span>
							<span style="color: red;">*</span>
							推荐封面图
						</span>

						<div style="font-size: 12px;color: #aaa;text-align: right;">370*700</div>
					</div>

					<upload-img @isShowLoading="isShowLoadingFn" :imgWidth="370" :imgHeight="700" :limit='1' accept="image/png" fileAfterName=".png" ref="tuiJianTuImgUpload" :imgList="tuiJianTu"></upload-img>
				</div>
				<div class="dis" style="justify-content: flex-end;">
					
					<el-button round style="margin-left: 10px" @click="tuiJianTuBtn" type="primary" size="small">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 推荐图弹窗end -->

		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
	</div>
</template>

<script>
	import uploadImg from '../../components/upload/uploadImg.vue'
	import {
		ajax
	} from '../../util/ajax.js';
	import addGoods from '../../components/goodsByCourse/addGoods.vue';
	import showGoods from '../../components/goodsByCourse/showGoods.vue';
	import editGoods from '../../components/goodsByCourse/editGoods.vue';
	export default {
		name: '',
		components: {
			addGoods,
			showGoods,
			editGoods,
			uploadImg
		},
		data() {
			return {
				storeList:[],//门店列表
				isShowTuiJianTuPop: false,
				tuiJianTu: [],

				mobileWidth: window.mobileWidth,

				isMobile: window.isMobile,
				isShowPricePop: false,
				currentPriceRowGoods_specsArr:[],
				currentPriceRow: '',

				rowGoods_id: '', //列表项的商品id

				isShowCollapse: false, //是否展开搜索项
				searchForm: {
					understock:""

				},
				currentItem:"",//当前行数据对象
				brand_idArr: [], //品牌列表
				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址

				isShowAddGoodsPop: false, //是否显示添加商品弹窗
				isShowGoodsDetailPop: false, //是否显示商品详情弹窗
				isShowEditGoodsPop: false, //是否显示编辑商品详情弹窗


				tableHeight: 0, //表格高度
				loading: false,
				tableData: [], //表格数据
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				shang: require("@/assets/shang.png"),
				xia: require("@/assets/xia.png"),
				sortIndex: -1, //排序项
				sortContent: '', //排序项的值 desc 或esc
				sortFlag: true, //排序箭头切换


				typeOptions: [], //分类列表
        sales_count:0,
        is_postage:0,
			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},
		created() {
			console.log("缓存已清除99991")
			this.getTableHeight();
		},
		mounted() {
			
			

			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};

			if (this.$route.query.understock) { //待发货状态的
				this.searchForm.understock = Number(this.$route.query.understock);
			}


			if (this.$route.query.goodsUpDownStatus) { //仓库中的商品的
				console.log('this.$route.query.goodsUpDownStatus', this.$route.query.goodsUpDownStatus)
				this.searchForm.status = Number(this.$route.query.goodsUpDownStatus);
			}



			this.getBrandIDArr();
			this.getTypeArrArr();
			this.getStore();
			this.initData();
		},

		methods: {
			//获取门店列表
			async getStore(){
				let ress = await ajax('/hq/store', 'GET');
				let res = ress.data.data;
				this.storeList = res.store;
			},
			//上传图片和视频时是否显示loading
			isShowLoadingFn(bool) {
				this.loading = bool
			},

			//初始化表格数据
			async initData() {
				this.loading = true
				var searchForm = this.searchForm;

				if (searchForm.brand_id === "") { //select未选中为空字符串
					searchForm.brand_id = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.name === "") { //select未选中为空字符串
					searchForm.name = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.status === "") { //select未选中为空字符串
					searchForm.status = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.category_id === "") { //select未选中为空字符串
					searchForm.category_id = undefined; //为null后就不会作为http请求参数了带给后端了
				}




				if (searchForm.store_id === "") { //select未选中为空字符串
					searchForm.store_id = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.is_recommend === "") {
					searchForm.is_recommend = undefined; //搜索的 是否推荐
				}

				if (searchForm.is_discount === "") {
					searchForm.is_discount = undefined; //搜索的 是否优惠
				}
				if (searchForm.understock === "") {
					searchForm.understock = undefined; //搜索的 库存
				}




				let param = {
					activity_type:3,//商品类型 (0: 普通商品, 1: 卡券商品, 2: 积分商品,3课时商品，4课时活动商品)
					
					...searchForm,
	

					count: this.pageSize,
					page: this.pageNumber
				}
				if(searchForm.typeArr&&searchForm.typeArr.length>0 ){
					param.category_id = searchForm.typeArr[1];
				}
				
				if (searchForm.sort) {
					param.sort = searchForm.sort; //排序的属性名
					param.sort_rule = searchForm.sort_rule; //排序的方式
				}
				
				
				let ress = await ajax('/goods/list', 'GET', param);
				this.loading = false;
				let res = ress.data.data;

				this.total = res.total;
				this.tableData = res.goods;
			},

			//多规格价格弹窗
			showPricePop(row) {
				this.currentItem = row;
				this.currentPriceRow = row;
				this.isShowPricePop = true;
        this.sales_count = row.sales_count
        this.is_postage = row.is_postage
				this.currentPriceRowGoods_specsArr = JSON.parse(JSON.stringify(this.currentPriceRow.goods_specs));
			},

			//获取品牌列表
			async getBrandIDArr() {
				this.loading = true
				let res = await ajax('/hq/brand', 'GET'); //获取品牌列表
				let arr = res.data.data.brand;
				this.loading = false;
				this.brand_idArr = arr;
			},

			//获取一级和二级分类列表
			async getTypeArrArr() {
				this.loading = true
				let res = await ajax('/hq/classes/category/list', 'GET'); //获取一级分类列表
				
				let arr = res.data.data.classes;
				console.log('分类=>', arr)
				
				
				let typeArr = [];
				for (let i of arr) {
					let obj = {
						value: i.id + '',
						label: i.name,
						children: []
					};
				
				
					let resChild = i.category;//获取二级分类列表
				
					for (let ii of resChild) {
						obj.children.push({
							value: ii.id,
							label: ii.name
						});
					}
					typeArr.push(obj);
				}
				
				this.loading = false;
				this.typeOptions = typeArr;
				
				
				
			},


			//点击查看商品按钮
			showGoodsDetail(item) {
				this.rowGoods_id = item.id;
				this.isShowGoodsDetailPop = true;
			},
			//点击修改商品按钮
			showEditGoods(item) {
				console.log('ssssssssss=>>>', item.id)
				this.rowGoods_id = item.id;
				this.isShowEditGoodsPop = true;

			},
			//删除商品
			async delGoods(row) {
				let text = '确定要删除?';
				

				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/goods/delete', 'DELETE', {
						goods_id: row.id
					});
					this.loading = false;
					this.$message({
						message: '成功',
						type: 'success'
					});

					this.initData();
				});

			},

			//点击列表的优惠按钮
			youhuiSwitchChange(item) {
				console.log('商品项', item)
				this.currentItem = item;
				this.fastEditGoods('is_discount');

			},
			
			//点击列表的会员按钮
			huiyuanSwitchChange(item) {
				console.log('商品项', item)
				this.currentItem = item;
				this.fastEditGoods('is_vip');
			
			},
			
			storeSwitchChange(item) {
				console.log('商品项', item)
				this.currentItem = item;
				this.fastEditGoods('is_store');
			
			},
			
			//点击列表的优惠卷抵扣按钮
			couponSwitchChange(item) {
				console.log('商品项', item)
				this.currentItem = item;
				this.fastEditGoods('is_coupon');
			
			},
			
			
			
			//点击列表的课时按钮
			keshiSwitchChange(item) {
				console.log('商品项', item)
				this.currentItem = item;
				this.fastEditGoods('is_course');
			
			},
			
			

			//点击列表中的推荐按钮
			tuiJianSwitchChange(item) {
				this.currentItem = item;
				if(item.is_recommend){
					this.isShowTuiJianTuPop = false;
					this.fastEditGoods('is_recommend')
				}else{
					this.isShowTuiJianTuPop = true;
					if(item.recommend_image){
						this.tuiJianTu = [{url:item.recommend_image}]
					}else{
						this.tuiJianTu=[];
					}
					
				}
				
			},
			
			//多规格修改价格弹窗上的确认按钮
			async duoSkuEditBtn(){
				let arr = this.currentPriceRowGoods_specsArr;
				console.log('this.currentItem',arr)
				for (let i of arr) {
					if (!i.supply_price.trim()) {
						this.$message.error('请填写商品供货价');
						return
					}
					if (!i.course) {
						this.$message.error('请填写课时价');
						return
					}
					// if (!i.original_price.trim()) {
					// 	this.$message.error('请填写商品原价');
					// 	return
					// }
					if (!i.price.trim()) {
						this.$message.error('请填写商品会员价');
						return
					}
					
					// if (!i.city_price.trim()) {
					// 	this.$message.error('请填写商品城代价');
					// 	return
					// }
					// if (!i.stock&&i.stock==="") {
					// 	this.$message.error('请填写商品库存');
					// 	return
					// }
					
					
					if (Number(i.supply_price) > Number(i.price)) {
						this.$message.error('供货价不能大于会员价');
						return
					}
				}
				
				let arr2 = [];
				for (let item of arr) {
					arr2.push( {
						"id": item.id, 
						course:item.course,
						"credit": 0, 
						"original_price": item.price, 
						"price": item.price, 
						"supply_price": item.supply_price, 
						"city_price": item.supply_price,
            "stock": item.stock,
						})
				}
				
				this.loading = true
				let res = await ajax('/goods/price/edit', 'PUT', {
					goods_id: this.currentItem.id,
          is_postage:this.is_postage,
          sales_count:this.sales_count,
					specs_price:arr2
				});
				
				this.loading = false;
				this.$message({
					message: '成功',
					type: 'success'
				});
				this.isShowTuiJianTuPop = false;
				this.isShowPricePop=false;
				this.initData();
				
			},

			//快捷修改商品信息
			async fastEditGoods(type,val) {
				console.log('=====数组====>',val)
				

				this.loading = true
				let res = await ajax('/goods/detail', 'GET', {
					goods_id: this.currentItem.id
				});
				let goodsDetail = res.data.data.goods;
				console.log('goodsDetail.goods_specs=>',goodsDetail.goods_specs);
				let specs = [];
				if(type=='price'){//修改价格的
					for (let index in goodsDetail.goods_specs) {
						goodsDetail.goods_specs[index].supply_price = val[index].supply_price;
						goodsDetail.goods_specs[index].original_price = val[index].original_price;
						goodsDetail.goods_specs[index].price = val[index].price;
						goodsDetail.goods_specs[index].city_price = val[index].city_price;
					}
				}
				
				//修改状态的
				goodsDetail.is_recommend = type == 'is_recommend' ? goodsDetail.is_recommend ? 0 : 1 : goodsDetail.is_recommend; //反着来，如果为true那么就修改为false,
				goodsDetail.recommend_image =  type == 'is_recommend' ? goodsDetail.is_recommend ? goodsDetail.recommend_image :  val: goodsDetail.recommend_image; //反着来，如果为true那么就修改为false,goodsDetail.recommend_image,
				goodsDetail.is_discount = type == 'is_discount' ? goodsDetail.is_discount ? 0 : 1 : goodsDetail.is_discount; //反着来，如果为true那么就修改为false
				goodsDetail.is_vip = type == 'is_vip' ? goodsDetail.is_vip ? 0 : 1 : goodsDetail.is_vip; //反着来，如果为true那么就修改为false
				goodsDetail.is_course = type == 'is_course' ? goodsDetail.is_course ? 0 : 1 : goodsDetail.is_course; //反着来，如果为true那么就修改为false
				goodsDetail.is_coupon = type == 'is_coupon' ? goodsDetail.is_coupon ? 0 : 1 : goodsDetail.is_coupon; //反着来，如果为true那么就修改为false
				goodsDetail.is_store = type == 'is_store' ? goodsDetail.is_store ? 0 : 1 : goodsDetail.is_store; //反着来，如果为true那么就修改为false
				
				
				
				let specs2 = []; //商品规格sku
				if (goodsDetail.specs_type == '1') { //单规格
					if(goodsDetail.goods_specs[0].deleted_at){
						goodsDetail.goods_specs = [];
					}
				}
				if (goodsDetail.specs_type == '2') { //多规格
					for (let item of goodsDetail.goods_specs) {
						if(item.deleted_at==null){
							specs2.push(item)
						}

					}
					goodsDetail.goods_specs =specs2;
				}
				
				if(goodsDetail.store==null){
					goodsDetail.store=undefined
				}
				
				
				goodsDetail.status =  goodsDetail.deleted_at?0:1;
				
				goodsDetail.goods_id =  goodsDetail.id;
			
				
				let ress = await ajax('/goods/edit', 'PUT', goodsDetail);
				this.loading = false;

				this.$message({
					message: '成功',
					type: 'success'
				});
				this.isShowTuiJianTuPop = false;
				this.isShowPricePop=false;
				this.initData();

			},

			//显示或隐藏添加商品弹窗
			showAddGoodsPop() {
				
				this.isShowAddGoodsPop = true;
			},
			//点击快捷推荐图的确认按钮
			tuiJianTuBtn(){
				let recommend_image = this.$refs.tuiJianTuImgUpload.getImgList(); //推荐封面图
				
				if (recommend_image.length == 0) {
					this.$message.error('请上传推荐封面图');
					return
				}
				console.log('recommend_image=>',recommend_image)
				this.fastEditGoods('is_recommend',recommend_image[0].url)
			},

			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 250; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},



			//展开搜索项
			isShowCollapseF() {
				this.isShowCollapse = !this.isShowCollapse;
			},
			//翻页
			changePage(pageNumber) {
				this.tableData = []; //这种可以让滚动条回到顶部
				this.pageNumber = pageNumber
				this.initData()
			},

			//点击头像
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},


			//排序 index是点击的项的索引,formName是属性名
			sort(index, formName) {
				//点击了默认排序
				if (index == -1) {
					this.sortIndex = -1;
					this.sortContent = ''; //排序的值 desc / esc
					this.sortFlag = true;
					//使用index把所有的搜索项值为''然后再发送请求获取到默认列表
					this.pageNumber = 1; //页码修改为1
					this.tableData = []; //表格数据修改为空
					this.searchForm.sort = undefined; //排序的属性名
					this.searchForm.sort_rule = undefined; //排序的方式
					//获取默认排序的表格数据

					this.initData(); //获取默认排序的表格数据
					return
				}
				//点击还是当前搜索项那么就进行升降序切换
				if (index == this.sortIndex) {
					this.sortFlag = !this.sortFlag;
					//把当前点击的搜索项切换为desc为降序
					if (this.sortFlag) {
						this.sortContent = 'desc'; //排序的值 desc / esc
						//使用index把所有的搜索项值为''然后把当前点击的搜索项的值修改为desc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.sort_rule = 'desc'; //排序的方式
						//获取表格列表

						this.initData(); //获取当前点击的搜索项的表格数据
					} else {
						//把当前点击的搜索项切换为esc为升序
						//使用index把所有的搜索项值为''然后把当前搜索项的值修改为asc
						this.sortContent = 'asc'; //排序的值 desc / asc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.sort_rule = 'asc'; //排序的方式
						//获取表格列表
						this.initData(); //获取当前点击的搜索项的表格数据
					}
					return
				}
				//当前点击的搜索项是其他的搜索项
				this.sortIndex = index; //当前点击的搜索项的索引号
				this.sortContent = 'desc'; //排序的值 desc / esc
				this.sortFlag = true;
				//使用index把所有的搜索项值为''然后把当前搜索项的值修改为desc然后再发送请求获取到列表
				this.pageNumber = 1; //页码修改为1
				this.tableData = []; //表格数据修改为空
				this.searchForm.sort = formName; //排序的属性名
				this.searchForm.sort_rule = 'desc'; //排序的方式
				//获取表格列表

				this.initData(); //获取当前点击的搜索项的排序的表格数据
			},


			//添加或编辑商品成功
			addAndEditGoodsSuccess() {
				console.log("接收到成功的通知")
				this.isShowAddGoodsPop = false;
				this.isShowEditGoodsPop = false;
				this.initData();
			},

			//搜索
			handleSearch() {
				this.pageNumber = 1;
				this.initData()
			},

			//重置
			handleReset() {
				
				this.$refs.searchForm.resetFields();
				this.searchForm = {};
				this.sortIndex = -1;
				this.sortContent = ''; //排序的值 desc / esc
				this.sortFlag = true;
				this.pageNumber = 1
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()
			},






		}


	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}
	
	>>>.dd input{
		text-align: center;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		padding-right: 20px;
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {

		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 95px;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}
</style>
